import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AlumnoLayout from "@/components/AlumnoLayout";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { fmtMxn } from "@/context/CartContext";
import { Download, ExternalLink, ShoppingBag } from "lucide-react";

const STATUS_STYLES = {
  pending_payment: "bg-amber-500/10 text-amber-300 border-amber-500/30",
  paid: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30",
  failed: "bg-red-500/10 text-red-300 border-red-500/30",
  cancelled: "bg-gray-500/10 text-gray-400 border-gray-700",
  refunded: "bg-brand-orange-500/10 text-brand-orange-300 border-primary/30",
  partially_refunded: "bg-brand-orange-500/10 text-brand-orange-300 border-primary/30",
};

export default function MisOrdenes() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/alumno/orders").then((r) => setOrders(r.data.items)).finally(() => setLoading(false));
  }, []);

  return (
    <AlumnoLayout user={user}>
      <div>
        <p className="text-xs uppercase tracking-widest text-[#93C5FD] font-semibold">Órdenes</p>
        <h1 className="mt-2 text-3xl font-bold text-white font-display">Historial de compras</h1>

        {loading ? (
          <div className="mt-6 h-32 bg-[#111827] border border-gray-800 rounded-xl animate-pulse" />
        ) : orders.length === 0 ? (
          <div className="mt-8 p-12 border-2 border-dashed border-gray-800 rounded-2xl text-center animate-fade-in-up" data-testid="orders-empty">
            <div className="w-16 h-16 mx-auto rounded-full bg-[#93C5FD]/10 border border-[#93C5FD]/30 flex items-center justify-center">
              <ShoppingBag className="w-8 h-8 text-[#93C5FD]" />
            </div>
            <p className="mt-4 text-lg font-semibold text-white">Aún no has realizado compras</p>
            <p className="mt-1 text-sm text-gray-400 max-w-sm mx-auto">
              Cuando compres un programa, la orden con detalles de pago aparecerá aquí.
            </p>
            <Link to="/catalogo" data-testid="orders-empty-cta"
              className="mt-5 inline-flex items-center gap-1 px-4 py-2 rounded-md bg-[#B84A0C] hover:bg-primary text-white text-sm font-semibold transition-all hover:scale-[1.02]">
              Explorar catálogo →
            </Link>
          </div>
        ) : (
          <div className="mt-6 overflow-x-auto border border-gray-800 rounded-xl" data-testid="orders-table">
            <table className="w-full text-sm">
              <thead className="bg-[#0F172A] text-xs uppercase tracking-widest text-gray-400">
                <tr>
                  <th className="text-left px-3 py-2">Número</th>
                  <th className="text-left px-3 py-2">Fecha</th>
                  <th className="text-left px-3 py-2">Programas</th>
                  <th className="text-right px-3 py-2">Total</th>
                  <th className="text-left px-3 py-2">Estado</th>
                  <th className="text-right px-3 py-2">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((o) => (
                  <tr key={o.id} className="border-t border-gray-800" data-testid={`order-row-${o.order_number}`}>
                    <td className="px-3 py-2 font-mono text-white">{o.order_number}</td>
                    <td className="px-3 py-2 text-gray-300 text-xs">{o.created_at?.slice(0, 10)}</td>
                    <td className="px-3 py-2 text-gray-300 text-xs">{(o.items || []).length} programa(s)</td>
                    <td className="px-3 py-2 text-right font-mono text-white">{fmtMxn(o.total_mxn)}</td>
                    <td className="px-3 py-2">
                      <span className={`text-[10px] px-2 py-0.5 rounded uppercase font-semibold border ${STATUS_STYLES[o.status] || STATUS_STYLES.pending_payment}`}>
                        {o.status}
                      </span>
                    </td>
                    <td className="px-3 py-2 text-right">
                      <Link to={`/app/alumno/ordenes/${o.id}`} data-testid={`order-view-${o.order_number}`}
                        className="inline-flex items-center gap-1 text-xs text-[#93C5FD] hover:text-white">
                        Ver <ExternalLink className="w-3 h-3" />
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </AlumnoLayout>
  );
}
